// MobileModeToggle — pill toggle that switches between Desktop and Mobile mode.
//
// Drop this into any admin page header. Reads/writes the shared `useMobileMode`
// hook, so toggling on POS instantly flips Quick Order, admin landing, etc.

import React from "react";
import { Monitor, Smartphone } from "lucide-react";
import { useMobileMode } from "@/hooks/useMobileMode";

export const MobileModeToggle = ({ className = "" }) => {
  const { mobileMode, setMobileMode } = useMobileMode();

  return (
    <div
      className={`inline-flex items-center rounded-full border border-white/10 bg-[#0a1628] p-0.5 ${className}`}
      data-testid="mobile-mode-toggle"
    >
      <button
        type="button"
        onClick={() => setMobileMode(false)}
        className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs transition-all ${
          !mobileMode
            ? "bg-amber-500 text-white shadow"
            : "text-slate-400 hover:text-white"
        }`}
        aria-pressed={!mobileMode}
        data-testid="mobile-mode-desktop-btn"
      >
        <Monitor size={14} />
        <span className="hidden sm:inline">Desktop</span>
      </button>
      <button
        type="button"
        onClick={() => setMobileMode(true)}
        className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs transition-all ${
          mobileMode
            ? "bg-emerald-500 text-white shadow"
            : "text-slate-400 hover:text-white"
        }`}
        aria-pressed={mobileMode}
        data-testid="mobile-mode-mobile-btn"
      >
        <Smartphone size={14} />
        <span className="hidden sm:inline">Mobile</span>
      </button>
    </div>
  );
};

export default MobileModeToggle;
